function r(r){return"string"==typeof r||Array.isArray(r)}export{r as isVariantLabel};
